import { render, staticRenderFns } from "./SurveyModule.vue?vue&type=template&id=263e7c77&"
import script from "./SurveyModule.vue?vue&type=script&lang=js&"
export * from "./SurveyModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports